import React from 'react'

import { SlideArrowStyled, SlideArrowItemStyled } from './styles'
import { IconArrow } from './../../../assets/svg/index'
import { IconArrowSmall } from './../../../assets/svg/index'

const SlideArrow = ({ className, onClick, isRotated, isSmall }) => {
  return (
    <SlideArrowStyled {...{ isSmall, isRotated }}>
      <SlideArrowItemStyled className={className} onClick={onClick}>
        {!isSmall ? <IconArrow /> : <IconArrowSmall />}
      </SlideArrowItemStyled>
    </SlideArrowStyled>
  )
}

export default SlideArrow
